import React, { useEffect, useState, useCallback } from 'react';
import Swal from 'sweetalert2';
import { useVendorManagementApi } from './useVendorManagementApi';

export const useVendorManagement = () => {
   const [vendorStats, setVendorStats] = useState({
      total: 0,
      active: 0,
      inactive: 0,
   });

   const [pagination, setPagination] = useState({
      page: 1,
      pageSize: 10,
      total: 0,
   });

   const [vendorFilters, setVendorFilters] = useState({
      vendorSearch: '',
      vendorStatus: 'all',
   });

   const [filteredVendors, setFilteredVendors] = useState([]);

   const { getVendorStats, getVendors, fetchingStats, fetchingVendors } = useVendorManagementApi();

   useEffect(() => {
      setPagination((prev) => ({
         ...prev,
         page: 1,
      }));

      GetVendors(1, pagination.pageSize, vendorFilters);
   }, [vendorFilters]);

   useEffect(() => {
      GetVendorStats();
   }, []);

   const GetVendors = async (page = 1, pageSize = 10, filters = vendorFilters) => {
      try {
         const data = await getVendors({
            page,
            pageSize,
            search: filters.vendorSearch,
            active: filters.vendorStatus,
         });
         setFilteredVendors(data.results);
         setPagination((prev) => ({
            ...prev,
            page,
            total: data.count,
         }));
      } catch (error) {
         console.error('Error fetching data:', error);
         setFilteredVendors([]);

         Swal.fire({
            title: 'Error',
            text: 'There was an error fetching the data. Please try again.',
            type: 'error',
         });
      }
   };

   const GetVendorStats = async () => {
      try {
         const data = await getVendorStats();
         setVendorStats(data);
      } catch (error) {
         console.error('Error fetching vendor stats:', error);
         setVendorStats({
            total: 0,
            active: 0,
            inactive: 0,
         });

         // This is excecuted together with GetVendors error, so no need to show twice
      }
   };

   const RefreshData = async (isByDelete = false) => {
      // If a page runs out of items, go back one page
      let page = pagination.page;
      if (
         isByDelete && // If the refresh is triggered by a delete action
         filteredVendors.length === 1 && // Only one item left on the page
         pagination.page > 1 // Not the first page
      ) {
         page = page - 1;
      }

      GetVendors(page, pagination.pageSize, vendorFilters);
      GetVendorStats();
   };

   // ______________________________________________________________________

   return {
      vendorStats,
      filteredVendors,

      vendorFilters,
      setVendorFilters,

      GetVendors,
      RefreshData,

      fetchingStats,
      fetchingVendors,

      pagination,
   };
};
